<template>
 
 <div class="page-content">
   <div class="edit-box">
    <div class='bg-whilt editInfo'>

      <!-- <label class='label'>
        <span class='labelTitle'>头像</span>
        <div class="img-box" @click="showInfoAvatar">
          <van-uploader :after-read="(file) => uploadImg(file)" name="shopLogo">
            <div class="camera-box center">
              <van-image :src="formData.headUrl||require('../assets/images/camera.png')" class="img"	fit="cover" />
            </div>
          </van-uploader>
          <div class="more"></div>
        </div>
      </label> -->

      <label class='label'>
        <span class='labelTitle'>姓名</span>
        <van-field
            class='input van-input'
            clearable
            v-model="formData.userName"
            name="userName"
            label=""
            placeholder="请输入姓名"
          />
      </label>
      <label class='label'>
        <span class='labelTitle'>手机号</span>
        <van-field
            class='input van-input'
            type="tel"
            v-model="formData.phone"
            name="phone"
            clearable
            maxlength="11"
            label=""
            placeholder="请输入手机号"
          />
      </label>
      <div class='label'>
        <span class='labelTitle'>短信验证码</span>
        <van-field
              class='input van-input'
              name="verificationCode"
              v-model="formData.code"
              clearable
              maxlength="6"
              label=""
              autocomplete="one-time-code"
              placeholder="请输入短信验证码"
            />
            <div class="getcode">
              <div v-show="showcount" @click="SendVerif">获取验证码</div>
              <div v-show="!showcount">{{ count }}s后获取</div>
            </div>
       
      </div>
    </div>

  </div>

    <div class="opt-box">
      <button class='btn apply-btn center float-ani' :disabled="buttonClicked" @click="submitForm">确定</button>
    </div>  

    <!-- 滑块验证码 -->
    <div v-if="showVerity">
      <Captcha
        :ref="(el)=>dialogopen = el"
        :l="42"
        :r="10"
        :w="catcha.w"
        :h="catcha.h"
        :sw="catcha.sw"
        :sh="catcha.sh"
        :blocky="catcha.blocky"
        :imgurl="catcha.imgurl"
        :miniimgurl="catcha.miniimgurl"
        :slider-text="catcha.text"
        @success="onSuccess"
        @fail="onFail"
        @refresh="onRefresh"
        @hideverify="hideVerify"
      />
    </div>





 </div>

</template>

<script setup name="staff">
import { reactive,ref, onMounted, toRefs, nextTick, getCurrentInstance} from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { Toast } from 'vant'


import { urlencode, getRouteQuery, redirectTo } from "@/utils/index";

// import { uploadFileApi } from '@/api/common'
import md5 from "js-md5"  //导入
import Captcha from '@/components/Captcha'


import { bindPhone, getKaptchaImg, checkKaptchaImg,sendMessageApi }  from '@/api/user'

const store = useStore()
const router = useRouter()
const { proxy } = getCurrentInstance() // as any  原型对象方法
proxy.$md5=md5   //md5转换为vue原型

const data =reactive({
   id: null,
   formData:{
    phone:"",
    uuid:"",
    code:"",
    userName:"",
  },
   buttonClicked: false,
    showVerity: false,  //是否显示滑块验证码      
    catcha: {
      blocky: 0,  //滑块y位置
      imgurl: '',   //大图url
      miniimgurl: '',   //小图url
      text: '向右滑动完成拼图', 
      h: 150,   //大图高
      w: 300,   //大图宽
      sh: 50,   //小图高
      sw: 40,   //小图宽
      modifyImg: ''
    }, // 图片验证码传值
    imageKey:null,  //图形验证码key
    verifyKey:null,  //图形验证码key
});
let {id,formData,buttonClicked,showVerity,catcha,imageKey,verifyKey} = toRefs(data);

//倒计时 参数
 const showcount = ref(true);
  const timer = ref();
  const TIME_COUNT = ref(60);
  const count = ref();
  const dialogopen = ref(null); //本质是reactive({value:null})


 const { redirect } = getRouteQuery()

  onMounted(async() => {

    formData.value.userName=store.getters['realName']|| store.getters['userName'];
     // 1.记录上一个页面的地址
      const { redirect } = getRouteQuery()
      if (redirect) {
        store.dispatch('setLandPage', redirect);
      }
      if(store.getters['enrollState'] == 1){
        router.push({
          path: store.getters.landPageRoute || '/',
          replace: true
        }); 
      }


  })
  



    // 图片上传（暂不需要上传头像）
    // const uploadImg = (file) => {
    //   var toast1 = Toast.loading({
    //     message: '上传中...',
    //     forbidClick: true,
    //   });
    //   const forms = new FormData()
    //   // 这里的file表示给后台传的属性名字，这里看接口文档需要传的的属性
    //   forms.append('file', file.file) // 获取上传图片信息
    //   uploadFileApi(forms).then(res => {
    //     toast1.clear();
    //     if (res.code == 200) {
    //       formData.value.headUrl = res.data.url;
    //     } else {
    //       Toast(res.message);
    //     }
    //   });
    // }



    // 注册
  const submitForm = () => {


    if(!formData.value.userName){
        Toast('请输入姓名！');
        return false;
    }
    if (!(/^(\((\+)?86\)|((\+)?86)?)0?1[3456789]\d{9}$/.test(formData.value.phone))) {
        Toast('请输入合法手机号！');
        return false;
    }
    if(!formData.value.code){
        Toast('请输入短信验证码！');
        return false;
    }

      buttonClicked.value = true

      bindPhone(formData.value).then(res => {
        Toast(res.message);
        buttonClicked.value = false
        if (res.code == 200) {
          //更新会员信息
          store.dispatch('QueryUserIsBind').then(res=>{
            //跳转
            router.replace({
              path: store.getters.landPageRoute || '/',
              replace: true
            }); 

          });
          // setTimeout(() => {
            
          // },1000)
        }
      }).catch(err=>{
           buttonClicked.value = false
      })
    }


   /**
    * 验证码事件
    */


    //显示滑块验证码
    const SendVerif = () => {

      if (!(/^(\((\+)?86\)|((\+)?86)?)0?1[3456789]\d{9}$/.test(formData.value.phone))) {
        Toast('请输入合法手机号！');
        return false;
      }

      getImageVerifyCode()

    }
    //隐藏滑块验证码
    const hideVerify = () => {
      showVerity.value = false;
    }
    //获取图形验证码
    const getImageVerifyCode = () => {
      let verifToast=Toast.loading({
        duration: 0, // 持续展示 toast
        message: '加载中...',
        forbidClick: true
      });

      let param = {
        uniqueId: formData.value.phone
      }
      getKaptchaImg(param).then(res => {
        verifToast.clear();
        if (res && res.data) {
          var imgobj = res.data
          imageKey.value = imgobj.imageKey;
          catcha.value.blocky = imgobj.points[0].y;
          catcha.value.imgurl = imgobj.images[0];
          catcha.value.miniimgurl = imgobj.images[1];        
          showVerity.value = true;
          nextTick(() => {
            dialogopen.value?.reset(imgobj.points[0].y);
          })
        }else{
          Toast(res.message||'获取图形验证码失败，请稍后重试！')
          // Notify({ 
          //   message: res.msg||'获取图形验证码失败，请稍后重试！'
          // });
        }
      }).catch(err=>{
        verifToast.clear();
      })
    }
    //验证成功
    const verifysuccess = () => {
      console.log('fail')
    }
    //滑块验证成功
    const onSuccess = (left) => {
      // this.loginForm.distance = left
      // console.log('succss', left)
      // 验证是否成功checkKaptchaImg是后台验证接口方法  
      let verifyContent = [{ X: parseInt(left), Y: catcha.value.blocky }];
      let md5Content = proxy.$md5(JSON.stringify(verifyContent) + '&' + imageKey.value);  
      // proxy.$md5(formState.password)
      let param = {
        uniqueId: formData.value.phone,
        imageKey: imageKey.value,
        verifyContent: JSON.stringify(verifyContent),
        md5Content: md5Content.toUpperCase()
      }
      checkKaptchaImg(param).then(res => {
        if (res && res.code == 200 && res.data && res.data.isError == false) {
          verifyKey.value = res.data.verifyKey;
          dialogopen.value?.handleSuccess();
          setTimeout(() => {
            showVerity.value = false
            catcha.value.imgurl = ''
            catcha.value.miniimgurl = ''
            //发送短信验证码
            sendMessage();
            // this.loginForm.distance = left
            // this.toLogin()
          }, 1000)
        } else {
          dialogopen.value?.handleFail(res.message)
          setTimeout(() => {
            getImageVerifyCode()
          }, 500)
        }
      }).catch(() => {
          dialogopen.value?.handleFail()
          setTimeout(() => {
            getImageVerifyCode()
          }, 500)
      })      
    }
    //刷新
    const onRefresh = () => {
      catcha.value.imgurl = ''
      catcha.value.miniimgurl = ''
      getImageVerifyCode()   
    }
    //失败
    const onFail = () => {
      console.log('fail')
    }
    
    //发送短信验证码
    const sendMessage = () => {
      const param = {
        phone:decodeURIComponent(formData.value.phone),
        verifyKey:decodeURIComponent(verifyKey.value)
      }
      sendMessageApi(param).then(res => {
        if (res && res.code == 200) {
          formData.value.uuid = res.data;
          //倒计时
          if (!timer.value) {
            count.value = TIME_COUNT.value;
            showcount.value = false;
            timer.value = setInterval(() => {
              if (count.value > 0 && count.value <= TIME_COUNT.value) {
                count.value--;
              } else {
                showcount.value = true;
                clearInterval(timer.value);
                timer.value = null;
              }
            }, 1000);
          }
        }else{
          Toast(res.message||'发送短信失败，请稍后重试！')
          // Notify({ 
          //   message: res.msg||'发送短信失败，请稍后重试！'
          // });
        }
      }).catch((error) => {
        Toast(error.message||'发送短信失败，请稍后重试！')
        // Notify({ 
        //   message:  error.message||'发送短信失败，请稍后重试！'
        // });       
      }) 

    }







</script>

<style lang="less" scoped>
@import "../assets/style/mixin";

.edit-box{
 
  background: #fff;
  margin: 10px;
  border-radius: 10px;
}
.center{
  display: flex;
  align-items: center;
  justify-content: center;
}
.camera-box {
  justify-content: space-between;
}
.editInfo {
  line-height: 50px;
  margin-bottom: 13px;
  border-bottom: solid 1px #f2f2f2;
  border-top: solid 1px #f2f2f2;
  font-size: 14px;
  .label {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: solid 1px #f2f2f2;
    justify-content: space-between;
    padding-left: 1px;
    padding: 0 15px;
    position: relative;
    &:last-child {
      border: none;
    }
    .labelTitle {
      width: 100px;
      flex: none;
    }
    .img-box{
      width: 490px;
      flex-shrink: 1;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .img{
        width: 50px;
        height: 50px;
        margin: 10px 0;
        margin-right: 10px;
      }
    }
    .input {
      flex-grow:1;
      text-align: left;
      border: none;
      position: relative;
      width: auto;
      &:disabled{
        background: none;
      }
    }
    .more {
      flex: none;
      width: 7px;
      height: 7px;
      border-top: 1px solid #888;
      border-right: 1px solid #888;
      transform: rotate(45deg);
    }
  }
}

input::placeholder {
    color: #c8c9cc; /* 设置文字颜色 */
}


.opt-box {
  height: 89px;
  padding-bottom: env(safe-area-inset-bottom);
  .apply-btn {  
    position: fixed;
    bottom: 15px;
    padding: 0;
    left: 4%;
    width: 92%;
    height: 44px;
    background: #FA3474;
    border-radius: 5px;
    font-size: 15px;
    font-weight: 400;
    color: #FFFFFF;
    margin-bottom: env(safe-area-inset-bottom);
    border: none;
  }
}

// 获取验证码
.van-input{
    padding: 0;
}
.van-input::after{
 display: none;
}

.getcode {
  width: 100px;
  flex: none;
  text-align: right;
  font-size: 15px;
  font-weight: 400;
  color: @mainc;
}



</style>